import React from "react";
import "./SkillComponent.css";
import java from "../../../assets/java.png";

export default function SkillComponent(props) {
    return         <div className="Image">
                        <img className="skill-style" src={props.source}/>
                        <p>{props.skillName}</p>
                    </div>
}